<template>
  <div class="numerology-pdf">
    YOOOS
    <h1>Générer une Étude Numérologique</h1>

    <div class="input-columns">
      <div class="column">
        <div>
          <label>Prénoms:</label>
          <input v-model="formData.firstName" />
        </div>

        <div>
          <label>Date de naissance:</label>
          <input type="date" v-model="formData.birthdate" />
        </div>

        <div>
          <label>Chemin de Vie:</label>
          <input type="number" v-model="formData.lifepath" />
        </div>

        <div>
          <label>Expression:</label>
          <input type="number" v-model="formData.expression" />
        </div>

        <div>
          <label>Realisation:</label>
          <input type="number" v-model="formData.realization" />
        </div>

        <div>
          <label>Moi Intime:</label>
          <input type="number" v-model="formData.intimate" />
        </div>

        <div>
          <label>Manquant:</label>
          <input v-model="formData.missing" />
        </div>

        <div>
          <label>Santé:</label>
          <input type="number" v-model="formData.health" />
        </div>

        <div>
          <label>Année:</label>
          <input type="number" v-model="formData.yearNumber" />
        </div>
      </div>

      <div class="column">
        <div>
          <label>Nom:</label>
          <input v-model="formData.lastName" />
        </div>

        <div>
          <label>Genre:</label>
          <select v-model="formData.gender">
            <option value="male">Homme</option>
            <option value="female">Femme</option>
          </select>
        </div>

        <div>
          <label>Ville de Naissance:</label>
          <input type="number" v-model="formData.birthCity" />
        </div>

        <div>
          <label>Année Actuelle:</label>
          <input type="number" v-model="formData.currentYear" />
        </div>

        <div>
          <label>Actif:</label>
          <input type="number" v-model="formData.active" />
        </div>

        <div>
          <label>Hérédité:</label>
          <input type="number" v-model="formData.heredity" />
        </div>

        <div>
          <label>Karma:</label>
          <input type="number" v-model="formData.karma" />
        </div>

        <div>
          <label>Dominant:</label>
          <input v-model="formData.dominant" />
        </div>
      </div>
    </div>

    <b-button @click="generatePDF" variant="success" :disabled="isSending">
      <span v-if="isSending">Génération en cours...</span>
      <span v-else>Générer un PDF</span>
    </b-button>

    <p v-if="lastPdfUrl">
      Dernier PDF généré: <a :href="lastPdfUrl">Étude Numérologique pour {{ formData.firstName }}</a>
    </p>

    <hr />
    <h3>Mandala</h3>
    <div>
      <label>Prompt:</label>
      <input type="text" v-model="mandalaPrompt" />
    </div>

    <b-button @click="generateMandala" variant="success" :disabled="isSending">
      <span v-if="isSending">Génération en cours...</span>
      <span v-else>Générer un Mandala</span>
    </b-button>

    <img v-if="imageUrl" :src="imageUrl" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { GENERATE_NUMEROLOGY_PDF, GENERATE_NUMEROLOGY_MANDALA } from "../../../store/actions";

import { BButton } from "bootstrap-vue";

export default {
  name: "PdfNumerologyGenerator",
  components: {
    BButton,
  },
  data() {
    return {
      formData: {
        firstName: "Helena",
        lastName: "Parfeniuk",
        gender: "female",
        birthdate: "15.05.1991",
        lifepath: "4",
        expression: "2",
        realization: "2",
        intimate: "2",
        active: "2",
        heredity: "2",
        karma: "1",
        dominant: "2",
        missing: "1,3,5,6,8,9",
        health: "2",
        yearNumber: "7",
        birthCity: "5",
        currentYear: 2024,
      },
      mandalaPrompt: "",

      lastPdfUrl: "",
      imageUrl: "",

      isSending: false,
    };
  },
  /* beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.isAuthenticated) next({ name: "login" });
    });
  }, */
  methods: {
    ...mapActions("numerology", {
      generateNumerologyPdf: GENERATE_NUMEROLOGY_PDF,
      generateNumerologyMandala: GENERATE_NUMEROLOGY_MANDALA,
    }),
    async generatePDF() {
      this.isSending = true;
      this.lastPdfUrl = "";

      const { formData } = this;

      const { pdfUrl } = await this.generateNumerologyPdf(formData);
      this.lastPdfUrl = pdfUrl;

      this.isSending = false;

      setTimeout(() => {
        window.open(pdfUrl, "_blank");
      }, 5000);
    },
    async generateMandala() {
      this.isSending = true;

      const { mandalaPrompt: prompt } = this;
      const { imageUrl } = await this.generateNumerologyMandala({ prompt });
      console.log("imageUrl", imageUrl);
      this.imageUrl = imageUrl;

      this.isSending = false;
    },
  },
};
</script>

<style scoped>
.numerology-pdf {
  max-height: 80vh;
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-columns {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0 10px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

select {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
}

button {
  padding: 10px 20px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

button:disabled {
  background-color: #c0c0c0;
  cursor: not-allowed;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
}

.error input {
  border-color: red;
}

.error p {
  color: red;
  font-size: 12px;
}
</style>
